import React from 'react';

const Stats = () => {
  return (
    <section className="py-20 bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 text-center">
          <div>
            <div className="text-4xl md:text-5xl font-bold mb-2">150+</div>
            <h5 className="text-xl font-semibold mb-4">Fashion Shoots</h5>
            <p className="text-gray-300">
              Professional fashion photography sessions completed for brands, 
              designers, and individual clients across various styles and concepts.
            </p>
          </div>

          <div>
            <div className="text-4xl md:text-5xl font-bold mb-2">50+</div>
            <h5 className="text-xl font-semibold mb-4">Happy Clients</h5>
            <p className="text-gray-300">
              Satisfied clients including fashion designers, brands, models, 
              and agencies who trust us with their visual storytelling needs.
            </p>
          </div>

          <div>
            <div className="text-4xl md:text-5xl font-bold mb-2">25+</div>
            <h5 className="text-xl font-semibold mb-4">Brand Campaigns</h5>
            <p className="text-gray-300">
              Successful brand campaigns and commercial projects that have 
              elevated our clients' visual presence and market impact.
            </p>
          </div>

          <div>
            <div className="text-4xl md:text-5xl font-bold mb-2">95%</div>
            <h5 className="text-xl font-semibold mb-4">Client Satisfaction</h5>
            <p className="text-gray-300">
              Outstanding client satisfaction rate reflecting our commitment 
              to excellence and delivering results that exceed expectations.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;